import { render, staticRenderFns } from "./ChatroomMessage.vue?vue&type=template&id=9cfd892e&scoped=true&"
import script from "./ChatroomMessage.vue?vue&type=script&lang=js&"
export * from "./ChatroomMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomMessage.vue?vue&type=style&index=0&id=9cfd892e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfd892e",
  null
  
)

export default component.exports